import { takeLatest, takeEvery } from 'redux-saga/effects';
import { EmailReportsApi } from '../api';

import {
  loadEmailReportsAction, createEmailReportAction, deleteEmailReportAction, updateEmailReportAction,
} from '../reducers/email-reports.reducers';
import {
  loadEmailReports, createEmailReport, deleteEmailReport, updateEmailReport,
} from './email-reports.sagas';


export * from './auth.sagas';
export * from './email-reports.sagas';

export const createEmailReportsSagas = (apiHost, optionProvider, requestOptions, brand, clientType) => {
  const emailReportsApi = new EmailReportsApi(apiHost, optionProvider, requestOptions, brand, clientType);

  return [
    takeLatest(loadEmailReportsAction.INIT, loadEmailReports, emailReportsApi),
    takeEvery(createEmailReportAction.INIT, createEmailReport, emailReportsApi),
    takeEvery(deleteEmailReportAction.INIT, deleteEmailReport, emailReportsApi),
    takeEvery(updateEmailReportAction.INIT, updateEmailReport, emailReportsApi),
  ];
};
